import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";

@Component({
    selector: "badrequest",
    templateUrl: "./badrequest.component.html",
    standalone: true,
    imports: [CommonModule]
})
export class BadRequestComponent {

}
